module.exports = __webpack_public_path__ + "img/reynolds-hero.c736f204.png";